module.exports = __webpack_public_path__ + "img/mob1.dfec2da2.png";